window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useModulePlugin('FilterAPI', {
            name: 'Ensure params',
            apply(builder) {
                builder.on('beforeMethodCall', 'get', (payload) => {
                    try {
                        if (typeof(payload.args[0]['pf_t_testing_use_application']) !== 'undefined' && payload.args[0]['pf_t_testing_use_application'].length > 0) {
                            payload.args[0].pf_t_testing_use_application_and_condition = true;
                        }
                    } catch (error) {
                        // console.log(error)
                    }
                });
            },
        });
    },
]);
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductTitle', {
            name: 'Modify Component ProductTitle',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    try {
                        const props = element.getParams().props
                        const productData = element.getParentElm().getParentElm().getParentElm().getParams().props.product
                        let productItem = document.querySelector('.boost-sd__product-item-list-view-layout[data-product-id="' + productData.id + '"]');
                        const text = productData.body_html
                        let extractedText = text.match(/\|\|(.*?)\|\|/);
                        if (productItem && !productItem.querySelector('.custom-description') && extractedText && extractedText[1]) {
                            productItem.querySelector('.boost-sd__product-item-list-view-layout-price').insertAdjacentHTML('beforebegin', '<p class="custom-description">' + extractedText[1] + '</p>')
                        }
                    } catch (error) {
                        console.log(error)
                    }
                },
            }),
        });
    }
]);
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductList', {
            name: 'Modify Component ProductList',
            enabled: true,
            apply: () => ({
                beforeRender(element) {
                    try {
                        const ViewAsElms = document.querySelectorAll('.boost-sd__view-as > .boost-sd__tooltip')
                        if (ViewAsElms && ViewAsElms.length > 1) {
                            ViewAsElms[1].querySelector('.boost-sd__view-as-icon').click()
                        }
                    } catch (error) {
                        console.log(error)
                    }
                },
            }),
        });
    }
]);
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductTitle', {
            name: 'Modify Component FormatCurrency',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    try {
                        const props = element.getParams().props
                        const titleElm = element.getRootElm()
                        if (titleElm) titleElm.textContent = props.title
                    } catch (error) {
                        console.log(error)
                    }
                },
            }),
        });
    }
]);